import { useEffect, useState } from 'react';
import { getOverviewPcConsoleTimeline } from '@/pages/opinion/services';
import { dealwithPcConsoleTimeline, defaultTimelineData } from '../utils';
import moment from 'moment';

export default function useGetStoreTimeline({
  keepParams,
  channel = ['opencritic', 'metacritic', 'steam'],
  formatTimeline,
}: {
  keepParams: any;
  channel?: Array<'opencritic' | 'metacritic' | 'steam'>;
  formatTimeline?: boolean;
}) {
  const [userScoreTrendsLoading, setUserScoreTrendsLoading] = useState(false);
  const [userScoreTrendsApiError, setUserScoreTrendsApiError] = useState(false);
  const [globalTrendsTimeline, setGlobalTrendsTimeline] = useState(
    defaultTimelineData(),
  );

  const requestScoreTrends = () => {
    setUserScoreTrendsLoading(true);
    setUserScoreTrendsApiError(false);
    getOverviewPcConsoleTimeline({
      ...keepParams,
      channels: channel,
      channel: channel,
      metrics: ['recommend', 'non_recommend'],
      ret_metrics: ['recommend', 'non_recommend'],
      types: ['total', 'slice'],
    })
      .then((data: any) => {
        let { list, timeline_of_end_time, timeline_of_start_time } = data || {};
        if (formatTimeline) {
          timeline_of_start_time = moment(timeline_of_start_time)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
          timeline_of_end_time = moment(timeline_of_end_time)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
        }
        const localTrendsTimeline: any = dealwithPcConsoleTimeline(
          list,
          timeline_of_start_time,
          timeline_of_end_time,
        );
        setGlobalTrendsTimeline(localTrendsTimeline);
      })
      .catch(() => {
        setUserScoreTrendsApiError(true);
      })
      .finally(() => {
        setUserScoreTrendsLoading(false);
      });
  };

  useEffect(() => {
    if (keepParams && ['pc', 'console'].includes(keepParams.entity_type)) {
      requestScoreTrends();
    }
  }, [keepParams, channel]);

  return {
    globalTrendsTimeline,
    userScoreTrendsLoading,
    userScoreTrendsApiError,
  };
}
